import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { EExpandShopItems, EShopCategory } from './requestDto';

export const shopItems = (providerId: number, accessToken: string, category?: EShopCategory[], expand?: EExpandShopItems[]): IRequest => ({
    uri: '/v1/shop/items',
    method: 'GET',
    headers: {
        'ProviderId': `${providerId}`,
        'Authorization': `Bearer ${accessToken}`,
    },
    queryParams: {
        category: category?.join(','),
        expand: expand?.join(','),
    },
});

